import axiosCultureAPI from './axiosCultureAPI';

import { Culture, CultureSort, UserCulture } from '../models/Culture';

export class CultureAPI {
    GetCultures(search?: string, scope: string = 'system'): Promise<Culture[]> {
        const params = new URLSearchParams();
        params.set('scope', scope);
        if (search) {
            params.set('search', search);
        }
        return new Promise((resolve, reject) => {
            axiosCultureAPI
                .get(`/cultures?${params.toString()}`)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    GetCulture(id: number): Promise<Culture> {
        return new Promise((resolve, reject) => {
            axiosCultureAPI
                .get(`/cultures/${id}`)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    GetSorts(cultureId: number): Promise<CultureSort[]> {
        return new Promise((resolve, reject) => {
            axiosCultureAPI
                .get(`/cultures/${cultureId}/sorts`)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    // --- My cultures (личный список пользователя) ---

    GetMyCultures(): Promise<UserCulture[]> {
        return new Promise((resolve, reject) => {
            axiosCultureAPI
                .get('/my_cultures')
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    AddMyCulture(cultureId: number, sortId?: number): Promise<UserCulture> {
        const body: any = { culture_id: cultureId };
        if (sortId) {
            body.sort_id = sortId;
        }
        return new Promise((resolve, reject) => {
            axiosCultureAPI
                .post('/my_cultures', body)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    UpdateMyCulture(id: number, sortId: number | null): Promise<UserCulture> {
        return new Promise((resolve, reject) => {
            axiosCultureAPI
                .put(`/my_cultures/${id}`, { sort_id: sortId })
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    DeleteMyCulture(id: number): Promise<any> {
        return new Promise((resolve, reject) => {
            axiosCultureAPI
                .delete(`/my_cultures/${id}`)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }
}

export const cultureAPI = new CultureAPI();
